import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  style: {
    "min-width": "25vw"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "width": "100%"
  },
  class: "flex-center"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "bi bi-arrow-clockwise rotate",
  style: {
    "font-size": "4rem",
    "color": "#0c0"
  }
}, null, -1);

const _hoisted_4 = {
  style: {
    "width": "100%",
    "font-weight": "bold",
    "text-align": "center"
  }
};
const _hoisted_5 = {
  key: 1,
  style: {
    "width": "100%",
    "flex-wrap": "wrap"
  },
  class: "flex-center"
};
const _hoisted_6 = {
  key: 0,
  style: {
    "width": "100%"
  },
  class: "flex-center"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.wwsimstore.com",
  target: "_blank"
}, "www.wwsimstore.com", -1);

const _hoisted_8 = {
  style: {
    "width": "100%",
    "margin-top": "1rem"
  },
  class: "flex-center"
};
const _hoisted_9 = {
  style: {
    "width": "100%",
    "margin-top": "1rem"
  },
  class: "flex-center"
};
const _hoisted_10 = {
  style: {
    "display": "flex",
    "justify-content": "between-space",
    "width": "100%"
  }
};
const _hoisted_11 = {
  style: {
    "width": "90%",
    "color": "#c00"
  }
};
const _hoisted_12 = {
  style: {
    "color": "#c00",
    "min-width": "25vw"
  }
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  style: {
    "min-width": "25vw"
  }
};
const _hoisted_16 = {
  style: {
    "margin": "1rem"
  }
};
const _hoisted_17 = {
  style: {
    "margin": "1rem"
  }
};
const _hoisted_18 = {
  style: {
    "font-weight": "bold"
  }
};
const _hoisted_19 = {
  style: {
    "margin": "1rem"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");

  const _component_el_button = _resolveComponent("el-button");

  const _component_Modal = _resolveComponent("Modal");

  const _component_Notice = _resolveComponent("Notice");

  const _component_router_view = _resolveComponent("router-view");

  const _directive_focus = _resolveDirective("focus");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Modal, {
    show: $data.loginModalShow,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $data.loginModalShow = $event),
    btnCloseShow: _ctx.userType == 'user' && _ctx.base == 'KnowledgeBase'
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx._t('login')), 1)]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_1, [$data.identifying ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx._t('identifying')), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_ctx.userType == 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString(_ctx._t('store')) + "：", 1), _hoisted_7])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString(_ctx._t('account')) + "：", 1), _withDirectives(_createVNode(_component_el_input, {
      type: "text",
      style: {
        "margin-left": "1rem",
        "width": "60%",
        "max-width": "12rem"
      },
      modelValue: $data.account,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.account = $event)
    }, null, 8, ["modelValue"]), [[_directive_focus]])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString(_ctx._t('password')) + "：", 1), _createVNode(_component_el_input, {
      type: "password",
      style: {
        "margin-left": "1rem",
        "width": "60%",
        "max-width": "12rem"
      },
      modelValue: $data.password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.password = $event),
      onKeypress: _withKeys($options.clickLogin, ["enter"])
    }, null, 8, ["modelValue", "onKeypress"])])]))])]),
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($data.loginHint), 1), _createVNode(_component_el_button, {
      onClick: $options.clickLogin
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx._t('login')), 1)]),
      _: 1
    }, 8, ["onClick"])])]),
    _: 1
  }, 8, ["show", "btnCloseShow"]), _createVNode(_component_Modal, {
    show: $data.msgModal.show,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.msgModal.show = $event)
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString($data.msgModal.title), 1)]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString($data.msgModal.content), 1)]),
    footer: _withCtx(() => [$data.msgModal.btn ? (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.btn, (_btn, _btnIndex) => {
      return _openBlock(), _createElementBlock("button", {
        class: "btn btn-self",
        onClick: $event => _btn.func()
      }, _toDisplayString(_btn.name), 9, _hoisted_14);
    }), 256))])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_Modal, {
    show: $data.workTimeModal.show,
    "onUpdate:show": _cache[4] || (_cache[4] = $event => $data.workTimeModal.show = $event)
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString($data.workTimeModal.title), 1)]),
    body: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx._t('workTimeHint1')), 1), _createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(_ctx._t('workTimeHint2')) + " ", 1), _createElementVNode("span", _hoisted_18, _toDisplayString($data.workTimeModal.cnLocalTime), 1), _createTextVNode(" " + _toDisplayString(_ctx._t('workTimeHint3')), 1)]), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx._t('workTimeHint4')), 1)])]),
    footer: _withCtx(() => []),
    _: 1
  }, 8, ["show"]), _createVNode(_component_Notice, {
    show: $data.homeNotice.show,
    "onUpdate:show": _cache[5] || (_cache[5] = $event => $data.homeNotice.show = $event),
    html: $data.homeNotice.html
  }, null, 8, ["show", "html"]), $data.waitShow ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
    class: "wait-self"
  })) : _createCommentVNode("", true), $options.htmlShow ? (_openBlock(), _createBlock(_component_router_view, {
    key: 1
  })) : _createCommentVNode("", true)], 64);
}